export function getFilenameFromHeaders(
	headers: Record<string, unknown> | Headers | undefined,
	url?: string,
	defaultName = 'download.bin'
): string {
	const get = (name: string): string | null => {
		if (!headers) return null

		if (headers instanceof Headers) {
			return headers.get(name) ?? headers.get(name.toLowerCase())
		}

		const h = headers as Record<string, unknown>
		const val = h[name] ?? h[name.toLowerCase()]

		if (val == null) return null
		if (Array.isArray(val)) return String(val[0])
		if (typeof val === 'string') return val
		return String(val)
	}

	const cd = get('Content-Disposition') ?? get('content-disposition')

	if (cd) {
		const star = cd.match(/filename\*\s*=\s*UTF-8''([^;]+)/i)
		const plain = cd.match(/filename\s*=\s*"?([^\";]+)"?/i)
		const raw = (star?.[1] || plain?.[1])?.trim()
		if (raw) {
			try {
				return decodeURIComponent(raw.replace(/\"/g, ''))
			} catch {
				return raw.replace(/\"/g, '')
			}
		}
	}

	if (url) {
		try {
			const base =
				typeof window !== 'undefined' && window.location?.origin
					? window.location.origin
					: 'http://localhost'
			const u = new URL(url, base)
			const last = u.pathname.split('/').pop()
			if (last && last.includes('.')) return last
		} catch {
			/* ignore */
		}
	}

	return defaultName
}

export const downloadBlob = (blob: Blob, filename: string): void => {
	const objectUrl = URL.createObjectURL(blob)
	const a = document.createElement('a')
	a.href = objectUrl
	a.download = filename
	document.body.appendChild(a)
	a.click()
	a.remove()
	URL.revokeObjectURL(objectUrl)
}
